'use client';

import { useEffect } from 'react';
import { deemaTracker } from './utils';
const DeemaTrackerClient = () => {
  useEffect(() => {
    deemaTracker.detectVisitFromURL();
  }, []);
  return null;
};
export default DeemaTrackerClient;